<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>DR性能检测虚拟仿真系统</h1>
      </div>

      <div class="ct-content">
        <!-- 文字在上，图片在下垂直布局 -->
        <div class="single-col-card">
          <div class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
          </div>
          <!-- 桌面全景大图 -->
          <div class="main-banner hidden-xs-only">
            <img
              :src="img[0]"
              alt="DR性能检测虚拟仿真系统，DR设备质控虚拟实训平台"
              class="banner-img"
              loading="lazy"
              decoding="async"
            />
            <div class="banner-glow"></div>
          </div>
          <!-- 多图组件 -->
          <ImgCol :imgList="img.slice(1)" class="step-list" />
          <!-- 移动端分类模块 -->
          <div class="infoDown hidden-sm-and-up">
            <h4 class="title-main">{{ grid[0] }}</h4>
            <div class="split-line"></div>

            <h4 class="sub-title">{{ grid[1] }}</h4>
            <el-row type="flex" style="flex-wrap:wrap" :gutter="20">
              <el-col :xs="6" v-for="(item,index) in grid.slice(1,5)" :key="index" class="xs-control pDRinfo">
                <div class="inside"><span>{{item}}</span></div>
              </el-col>
            </el-row>

            <h4 class="sub-title">{{ grid[2] }}</h4>
            <el-row type="flex" style="flex-wrap:wrap" :gutter="10">
              <el-col :xs="6" v-for="(item,index) in grid.slice(5,13)" :key="index" class="xs-control">
                <div class="inside"><span>{{item}}</span></div>
              </el-col>
            </el-row>

            <h4 class="sub-title">{{ grid[3] }}</h4>
            <el-row type="flex" style="flex-wrap:wrap" :gutter="10">
              <el-col :xs="6" v-for="(item,index) in grid.slice(13)" :key="index" class="xs-control">
                <div class="inside"><span>{{item}}</span></div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 行业参考标准区块 -->
        <div class="standard-block">
            <div class="refer-text">
              参考标准：中华人民共和国卫生行业标准   WS  76-2020  《医用X射线诊断设备质量控制检测规范》 等
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgCol from "@/components/imgCol.vue";
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "CheckDRPerformance",
  components: {
    ImgCol,
    PullDown
  },
  data() {
    return {
      wWidth: window.innerWidth,
      p: ["本系统匹配《医学影像设备学》实训教学要求，构建DR设备仿真模型及各类检测模体和虚拟场景（含操作间、检查室），对DR设备结构和检测模体实现1:1仿真再现、细节认知和模拟拆装。可实现对场景布局、模体组件细节和技术参数的深度认知和学习，并能进行管电压与曝光时间指示、辐射输出量重复性、AEC重复性等实验项目，将理论知识与临床实践紧密结合。"],
      img: [
        require("@/assets/pDR_last.png"),
        require("@/assets/pDR1.png"),
        require("@/assets/pDR2.png"),
        require("@/assets/pDR3.png")
      ],
      grid: [
        "DR性能检测",
        "检测器材认识",
        "基础实验",
        "拓展实验",
        "实验报告",
        "管电压与曝光时间指示",
        "辐射输出量重复性",
        "输出量线性",
        "有用线束半值层",
        "垂直度与光野四边偏离测量",
        "AEC重复性实验",
        "AEC响应",
        "AEC电离室之间一致性",
        "DDI与响应均匀性",
        "信号传递特性STP",
        "测距误差",
        "残影",
        "伪影",
        "高对比度分辨力",
        "低对比度细节"
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 统一标准文字样式（与CT页面完全一致）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // 全景大图样式复用CT
  .main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
  }
  .banner-img {
    width: 95%;
    padding: 10px 0;
    margin: 0 auto;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
  }

  // 移动端分类模块
  .infoDown {
    margin-top: 16px;

    .title-main {
      display: inline-block;
      padding: 18px 26px;
      margin: 10px 0 24px;
      font-size: 24px;
      color: #fff;
      background: #2563AF;
      border-radius: 8px;
      font-weight: 500;
    }

    .split-line {
      width: 80%;
      height: 4px;
      background: #2563AF;
      border-radius: 2px;
      margin: -10px 0 28px;
    }

    .sub-title {
      font-size: 20px;
      margin-bottom: 12px;
      color: #2563AF;
      font-weight: 500;

      &:nth-of-type(2) {
        margin-top: 24px;
      }
      &:last-of-type {
        margin-top: 14px;
      }
    }

    .xs-control {
      padding: 10px 0;

      .inside {
        width: 100%;
        min-height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 4px 14px rgba(10, 40, 70, 0.1);
        }

        span {
          font-size: 16px;
          font-weight: 300;
          color: #1e2a3a;
          text-align: center;
          line-height: 1.5;
        }
      }

      .pDRinfo .inside {
        margin-top: 22px;
        background: #2563AF;
        position: relative;
        &::before {
          content: '';
          height: 27px;
          width: 4px;
          position: absolute;
          top: -27px;
          left: 50%;
          transform: translateX(-50%);
          background: #2563AF;
          border-radius: 2px;
        }
        span { color: #fff; }
      }
    }
  }

  .block-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a3b66;
    text-align: center;
    margin: 0 0 24px;
  }

  // 参考标准卡片 与CT统一
  .book-card {
    background-color: #f0f7ff;
    border-radius: 12px;
    padding: 32px 24px;
    text-align: left;
  }
  .standard-card {
    border-left: 5px solid #2563AF;
    transition: all 0.3s ease;
  }
  .standard-card:hover {
    border-left-color: #67a6dc;
    box-shadow: 0 0 12px rgba(37, 99, 175, 0.15);
  }
  .refer-text {
    padding: 8px 12px;
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    text-align: left;
  }

  // ImgCol穿透样式 统一CT
  :deep(.imgCom) {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    margin-bottom: 14px;
  }
  :deep(.imgCom:hover) {
    transform: translateY(-3px);
    box-shadow: 0 10px 26px rgba(10, 40, 70, 0.12);
  }
  :deep(.imgCom img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
  }
  :deep(.imgCom:hover img) {
    transform: scale(1.04);
  }
}

// 暗色模式完整适配（与CT页面逻辑完全一致）
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        .infoDown {
          .sub-title { color: #60a5fa; }
          .xs-control .inside { background: #142033; span { color: #c8d6e8; } }
          .pDRinfo .inside { background: #2563AF; }
        }
        .block-title {
          color: #93bbfc;
        }
        .book-card {
          background: rgba(37, 99, 175, 0.12);
        }
        .refer-text {
          color: #b0c4de;
        }
        :deep(.imgCom) {
          background: #142033;
        }
      }
    }
  }
}

// 全局导航统一深度样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>